module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-control-wrapper",
    class: {
      'interface-hidden': _vm.interfaceHidden
    },
    on: {
      "mousemove": _vm.handleMouseMove,
      "mouseleave": _vm.handleMouseMove
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tab.current),
      expression: "!tab.current"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel),
      expression: "channel"
    }],
    attrs: {
      "id": "playInfo"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.channel.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "channel"
  }, [_vm._v(_vm._s(_vm.channel.name))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!isNaN(_vm.program.start) || !isNaN(_vm.program.end)),
      expression: "!isNaN(program.start) || !isNaN(program.end)"
    }],
    staticClass: "programm"
  }, [_vm._v(_vm._s(_vm.time(_vm.program.start)) + "–" + _vm._s(_vm.time(_vm.program.end)) + ". " + _vm._s(_vm.program.name))])])]), _vm._v(" "), _c('div', {
    style: ({
      height: !isNaN(_vm.program.start) || !isNaN(_vm.program.end) ? '' : '46px'
    }),
    attrs: {
      "id": "videoControl"
    }
  }, [_c('div', {
    staticClass: "progress",
    class: {
      'invisible': isNaN(_vm.program.start) || isNaN(_vm.program.end)
    }
  }, [_c('vueSlider', {
    attrs: {
      "tooltip": "hover",
      "lazy": true,
      "process-style": {
        background: '#f98d0b'
      },
      "slider-style": {
        boxShadow: 'none'
      },
      "bg-style": {
        borderRadius: '0'
      },
      "formatter": _vm.calcTimeline
    },
    on: {
      "callback": _vm.setProgress,
      "drag-start": _vm.handleProgressBarDragStart
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('a', {
    staticClass: "channellist",
    attrs: {
      "title": "Каналы"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTab('channels')
      }
    }
  }, [_c('i', {
    staticClass: "icon-menu"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playing),
      expression: "playing"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pause($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-control-pause"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playing),
      expression: "!playing"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.play($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-control-play"
  })]), _vm._v(" "), _c('a', {
    staticClass: "controls_volume",
    attrs: {
      "href": "#"
    },
    on: {
      "wheel": _vm.handleVolumeWheel,
      "click": function($event) {
        $event.preventDefault();
      },
      "mouseover": function($event) {
        return _vm.$refs.volumeSlider.refresh()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMuted),
      expression: "isMuted"
    }],
    staticClass: "icon-volume-off",
    on: {
      "click": _vm.mute
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMuted && _vm.volume <= 50),
      expression: "!isMuted && volume <= 50"
    }],
    staticClass: "icon-volume-1",
    on: {
      "click": _vm.mute
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMuted && _vm.volume > 50),
      expression: "!isMuted && volume > 50"
    }],
    staticClass: "icon-volume-2",
    on: {
      "click": _vm.mute
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "volume-slider"
  }, [_c('vueSlider', {
    ref: "volumeSlider",
    attrs: {
      "width": 4,
      "height": 100,
      "tooltip": false,
      "process-style": {
        background: '#f98d0b'
      },
      "slider-style": {
        boxShadow: 'none'
      },
      "bg-style": {
        borderRadius: '0'
      },
      "direction": "vertical"
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Громкость " + _vm._s(_vm.volume) + "%")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!isNaN(_vm.program.start) || !isNaN(_vm.program.end)),
      expression: "!isNaN(program.start) || !isNaN(program.end)"
    }],
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time(_vm.program.start)) + " / " + _vm._s(_vm.time(_vm.program.end)))]), _vm._v(" "), ((_vm.isLiveNow || (isNaN(_vm.program.start) || isNaN(_vm.program.end))) && _vm.playing) ? _c('span', [_vm._v("LIVE")]) : _vm._e(), _vm._v(" "), (_vm.playing && _vm.$parent.mode === 'archive') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("R")]) : _vm._e(), _vm._v(" "), (_vm.playing && _vm.$parent.mode === 'teleteka') ? _c('span', {
    staticStyle: {
      "color": "#2196F3"
    }
  }, [_vm._v("T")]) : _vm._e(), _vm._v(" "), (!_vm.playing) ? _c('span', [_vm._v("ПАУЗА")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav right"
  }, [_c('Quality-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!isNaN(_vm.program.start) || !isNaN(_vm.program.end)),
      expression: "!isNaN(program.start) || !isNaN(program.end)"
    }],
    ref: "qualitySelect",
    attrs: {
      "hls": _vm.hls,
      "quality": _vm.quality
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!isNaN(_vm.program.start) || !isNaN(_vm.program.end)),
      expression: "!isNaN(program.start) || !isNaN(program.end)"
    }],
    staticClass: "video-control_select-wrap select-format-wrap"
  }, [_vm._v("\n                    Формат:\n                    "), _c('select', {
    staticClass: "video-control_select default-select",
    domProps: {
      "value": _vm.videoAspectRatio.index
    },
    on: {
      "change": _vm.changeVideoAspectRatio
    }
  }, _vm._l((_vm.videoAspectRatio.modes), function(format, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(format))])
  }), 0)]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Настройки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTab('settings')
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "Выйти"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-power"
  })]), _vm._v(" "), _c('span', [(!_vm.isInFullScreen) ? _c('a', {
    staticClass: "fullscreen",
    attrs: {
      "title": "На весь экран",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fullScreen($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-size-fullscreen"
  })]) : _vm._e(), _vm._v(" "), (_vm.isInFullScreen) ? _c('a', {
    staticClass: "fullscreen",
    attrs: {
      "title": "Выйти из полноэкранного режима",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fullScreen($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-size-actual"
  })]) : _vm._e()])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f1d9790!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoControl.vue
// module id = 87
// module chunks = 0